import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import TooltipContainer from '../../components/shared/TooltipContainer/TooltipContainer';
import { ReactComponent as InfoIcon } from '../../assets/svg/InfoIconLight.svg';

type Props = {
  noTooltip?: boolean,
};

const PlacesLabel: FC<Props> = ({ noTooltip }) => {
  const [t] = useTranslation('supplierDatabase', {
    keyPrefix: 'supplierDetailPanel.profileInfo.places',
  });

  return (
    <>
      {t('title', 'Platser')}
      {!noTooltip && (
        <TooltipContainer
          renderReferenceComponent={(className, ref) => (
            <InfoIcon
              className={className}
              ref={ref}
              style={{ marginLeft: '8px', verticalAlign: 'bottom' }}
            />
          )}
        >
          <div style={{ maxWidth: '400px' }}>
            {t(
              'info',
              'Driftsområden kan läggas till av både dig och leverantören. De som leverantören lägger till kommer att prioriteras vid visning.',
            )}
          </div>
        </TooltipContainer>
      )}
    </>
  );
};

export default PlacesLabel;
